import {
    AnimationBaseController,
    IAnimationControllerConfiguration,
    Inject,
    SoundType,
} from '@denishussar/html5-game-engine';
import { AnimationContents } from '../../../AnimationContents';
import { ButtonController } from '../../Common/ButtonController';
import { GameLogic } from '../../Logic/GameLogic';
import { EndScreenTextEnum, GameModel } from '../../Models/GameModel';
import { SpineAnimationBaseController } from '../Spine/SpineAnimationBaseController';
import { SoundConstants } from '../../Constants/SoundConstants';
import { Referals } from '../../Constants/Referals';
import { FirebaseAPI } from '../../../FirebaseAPI';

export interface IEndScreenControllerOptions {}

export class EndScreenController extends AnimationBaseController {
    public $model: GameModel;

    private _spineAnimationController: SpineAnimationBaseController;

    public constructor(
        @Inject private _options: IEndScreenControllerOptions,
        @Inject private _gameLogic: GameLogic,
        @Inject private _firebaseAPI: FirebaseAPI
    ) {
        super('EndScreenController');
    }

    protected getConfiguration(): IAnimationControllerConfiguration {
        return <IAnimationControllerConfiguration>{
            animationContent: AnimationContents.END_SCREEN_JSON,
            libraryName: 'window',
            sounds: [
                {
                    id:SoundConstants.MINIGAME_LOOSE,
                    type: SoundType.SFX
                },
            ],
            childControllers: {
                spineAnimation: {
                    controller: SpineAnimationBaseController,
                    model: this.$model,
                    options: {
                        key: 'end',
                        url: `/images/spine/end_screen/end_screen.json`,
                        animations: [
                            'lose_initialize',
                            'lose_loop',
                            'win_initialize',
                            'win_loop',
                        ],
                    },
                },
                btn_vote: {
                    instanceName: 'btn_vote',
                    controller: ButtonController,
                    model: this.$model,
                    options: {
                        onClick: () => {
                            this._onVote();
                            window.open(Referals.vote, "_blank")
                        },
                    },
                },
                btn_again: {
                    instanceName: 'btn_again',
                    controller: ButtonController,
                    model: this.$model,
                    options: {
                        onClick: () => {
                            this._onRestart();
                            this._gameLogic.resetAppScreen()
                            this._gameLogic.showAfterloaderScreen(this.$model.showAfterloaderScreenNewPlayer);
                        },
                    },
                },
            },
            queue: {
                win: {
                    condition: clock => clock > 0.5,
                    action: () => {
                        this._spineAnimationController.setAnimation(
                            'win_loop',
                            true
                        );
                    },
                },
                lose: {
                    condition: clock => clock > 0.5,
                    action: () => {
                        this._spineAnimationController.setAnimation(
                            'lose_loop',
                            true
                        );
                    },
                },
            },
        };
    }

    protected onInitialize(): void {
        this._spineAnimationController =
            this.$childControllers.get('spineAnimation');
        this._spineAnimationController.y = -300;

        this._changeState(this.$model.showEndVictory);
        this.display.scale.set(0.75);
    }

    private _changeState(state: boolean): void {
        if (state) {
            this.gotoAndStop('victory');
            this.gotoAndStopByQuery('victory', this.$model.showEndType);

            this._spineAnimationController.setAnimation(
                'win_initialize',
                false
            );
            this.$queue.get('win').addToQueue();
        } else {
            this.gotoAndStop('defeat');
            this.gotoAndStopByQuery('defeat', this.$model.showEndType);

            this._spineAnimationController.setAnimation(
                'lose_initialize',
                false
            );
            this.$queue.get('lose').addToQueue();
        }
    }

    private _getEndType(): string {
        const type = this.$model.showEndType;
        const victory = this.$model.showEndVictory;

        let res = 0;

        if (victory) {
            switch (type) {
                case EndScreenTextEnum.txt1:
                    res = 3;
                    break;
                case EndScreenTextEnum.txt2:
                    res = 4;
                    break;
                case EndScreenTextEnum.txt3:
                    res = 5;
                    break;
            }
        } else {
            switch (type) {
                case EndScreenTextEnum.txt1:
                    res = 1;
                    break;
                case EndScreenTextEnum.txt2:
                    res = 2;
                    break;
                case EndScreenTextEnum.txt3:
                    res = 6;
                    break;
                case EndScreenTextEnum.txt4:
                    res = 7;
                    break;
            }
        }

        return res.toString();
    }

    private _onVote(): void {
        this._firebaseAPI.trackVote(this._getEndType());
    }

    private _onRestart(): void {
        this._firebaseAPI.trackGameRestart(this._getEndType());
    }
}
